export default {
  speakers: [],
  pagination: {},
  speaker: {}
}
